import { render, staticRenderFns } from "./Ciberseguridad.vue?vue&type=template&id=ebf4825c&scoped=true"
import script from "./Ciberseguridad.vue?vue&type=script&lang=js"
export * from "./Ciberseguridad.vue?vue&type=script&lang=js"
import style0 from "./Ciberseguridad.vue?vue&type=style&index=0&id=ebf4825c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf4825c",
  null
  
)

export default component.exports